import React from 'react';
import PropTypes from 'prop-types';

import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import { chip, activeChip, chipIcon, chipIconSolid, chipLabel } from '../styles/styles';

const styles = {
  chip,
  activeChip,
  chipIcon,
  chipIconSolid,
  chipLabel,
};

const useStyles = makeStyles(styles);

const CountChip = ({ count, label, onClick }) => {
  const classes = useStyles();

  return (
    <Chip
      className={classNames(classes.chip, {
        [classes.activeChip]: count > 0,
      })}
      size="medium"
      label={
        <div className={classes.chipLabel}>
          <div className={classNames(classes.chipIcon, classes.chipIconSolid)}>
            {count > 0 ? (
              count
            ) : (
              <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 1V10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1.5 5.5H10.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </div>
          {label}
        </div>
      }
      variant="outlined"
      clickable
      onClick={onClick}
    />
  );
};

CountChip.propTypes = {
  count: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CountChip;
